import React from 'react';
import styled from 'styled-components';
import { Form, Input, Button, Typography, Upload, message } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const { Title, Text } = Typography;
const { Dragger } = Upload;

const Container = styled.div`
  display: flex;
  min-height: calc(100vh - 4rem);
  padding: 2rem;
  align-items: center;
  justify-content: center;
  background-color: #f4f6fb;
`;

const SignUpSection = styled.div`
  max-width: 400px;
  padding: 2rem;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledButton = styled(Button)`
  width: 100%;
  padding: 0.75rem;
  font-weight: bold;
  border-radius: 8px;
  margin-top: 1rem;
`;

// const DraggerContainer = styled.div`
//   width: 100%;
//   margin-bottom: 1.5rem;
// `;

function SignUpForm() {
  const [idFrontFile, setIdFrontFile] = React.useState<File | null>(null);
  const [idBackFile, setIdBackFile] = React.useState<File | null>(null);
  const navigate = useNavigate(); 


  const onFinish = async (values: any) => {
    const formData = new FormData();
    formData.append('email', values.email);
    formData.append('password', values.password);
    formData.append('confirmPassword', values.confirmPassword);

    // Append the uploaded files
    if (idFrontFile) {
      formData.append('idFront', idFrontFile);
    }
    if (idBackFile) {
      formData.append('idBack', idBackFile);
    }

    try {

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/user/create-user`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      message.success('User created successfully!');

      navigate('/dashboard');
    } catch (error: any) {
      message.error(error?.response?.data?.message || 'Failed to create user.');
      console.error('Error:', error);
    }
  };

  const draggerPropsFront = {
    name: 'idFront',
    multiple: false,
    beforeUpload: (file: File) => {
      setIdFrontFile(file); // Store the file
      return false; // Prevent automatic upload
    },
  };

  const draggerPropsBack = {
    name: 'idBack',
    multiple: false,
    beforeUpload: (file: File) => {
      setIdBackFile(file); // Store the file
      return false; // Prevent automatic upload
    },
  };
  return (
    <Container>
      <SignUpSection>
        <Title level={2}>Sign Up</Title>
        <Text type="secondary">Create your account by filling out the form below</Text>
        
        <Form
          name="signup"
          layout="vertical"
          onFinish={onFinish}
          style={{ width: '100%', marginTop: '1.5rem' }}
        >
          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: true, message: 'Please enter your email!' }]}
          >
            <Input placeholder="Enter your email" />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: 'Please enter your password!' }]}
          >
            <Input.Password placeholder="Password" />
          </Form.Item>

          <Form.Item
            label="Confirm Password"
            name="confirmPassword"
            dependencies={['password']}
            rules={[
              { required: true, message: 'Please confirm your password!' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('Passwords do not match!'));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirm password" />
          </Form.Item>

          <Form.Item
          label="Upload ID Front"
          name="idFront"
          rules={[{ required: true, message: 'Please upload the front of your ID!' }]}
        >
          <Dragger {...draggerPropsFront}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Click or drag file to this area to upload</p>
            <p className="ant-upload-hint">Upload a clear front photo of your ID.</p>
          </Dragger>
        </Form.Item>

        <Form.Item
          label="Upload ID Back"
          name="idBack"
          rules={[{ required: true, message: 'Please upload the back of your ID!' }]}
        >
          <Dragger {...draggerPropsBack}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Click or drag file to this area to upload</p>
            <p className="ant-upload-hint">Upload a clear back photo of your ID.</p>
          </Dragger>
        </Form.Item>

          <StyledButton type="primary" htmlType="submit">
            Next Step
          </StyledButton>
        </Form>
      </SignUpSection>
    </Container>
  );
}

export default SignUpForm;
